<template id="billinfo">
   <div class="ivoiceColOuter">
      <div class="row">
        <div class="col-md-4 col-sm-12 col-xs-12 pull-right">
          <div class="invoiceCol text-center">
            <h1 v-if="isProforma()">{{res.proinvoice}}</h1>
            <h1 v-else>{{res.invoice}}</h1>
            <div class="invoicetext"> {{res.invoiceno}} <span>{{invoice.invoiceNo}}</span></div>
            <div class="invoicetext">{{res.invoicedate}}<span>{{invoice.curdate | fullDate(common_res.month['m'+(invoice.curdate.getMonth()+1)], common_res.fulldate)}}</span></div>
            <div v-if="invoice.status != null" class="invoicetext">{{res.orderstatus}}<span>{{invoice.status}}</span></div>
          </div>
        </div>
        <div class="col-md-8"> 
          <!-------->
          <div class="row">
            <div class="col-sm-12 bill_wrapper">
              <div class="bill">
                <div class="formHeadings"> <span><img src="@/images/bill.png" alt="#"></span>{{res.billto}}</div>
                <div class="billdesc">
                  <h6 v-html="companyinfo.name"></h6>
                  <p> 
                    {{companyinfo.address1}}<br v-if="companyinfo.address2 != ''">
                    {{companyinfo.address2}}<br v-if="companyinfo.address3 != ''">
                    {{companyinfo.address3}}<br v-if="companyinfo.address4 != ''">
                    {{companyinfo.address4}}
                  </p>
                  <ul>
                    <li><a href="#"><span> <img src="@/images/profileicon.png" alt="image"></span> {{res.attn}}: {{companyinfo.poc}}</a></li>
                    <li><a href="#"><span> <img src="@/images/phone-icon.png" alt="image"></span> {{companyinfo.tel}}</a></li>
                  </ul>
                </div>
              </div>
              <!--------->
              <div class="bill" v-if="shippinginfo != null">
                <div class="formHeadings">
                  <span><img src="@/images/ship.png" alt="#"></span>
                  {{res.shipto}}
                  <div class="dropdownRemote sender" name="shipto">
                    <a v-if="companyinfo.branches != null && companyinfo.branches.length > 0" v-on:click="toshowaddrs = !toshowaddrs" class="dropdownTrigger"><i class="fa fa-caret-down"></i></a>
                    <div class="dropdownList" v-if="toshowaddrs" style="display: block">
                      <ul>
                        <li><a v-on:click="selectBranch($event, companyinfo)" name="add_00">{{companyinfo.name}}</a></li>
                        <li v-for="(bch, bidx) in companyinfo.branches"><a v-on:click="selectBranch($event, bch)" name="add_01">{{bch.name}}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="billdesc">
                  <h6> {{shippinginfo.name}}</h6>
                  <p>
                    {{shippinginfo.address1}}<br v-if="shippinginfo.address2 != ''">
                    {{shippinginfo.address2}}<br v-if="shippinginfo.address3 != ''">
                    {{shippinginfo.address3}}<br v-if="shippinginfo.address4 != ''">
                    {{shippinginfo.address4}}
                  </p>
                  <ul>
                    <li><a href="#"><span> <img src="@/images/profileicon.png" alt="image"></span> {{res.attn}}: {{shippinginfo.poc}}</a></li>
                    <li><a href="#"><span> <img src="@/images/phone-icon.png" alt="image"></span> {{shippinginfo.tel}}</a></li>
                  </ul>
                </div>
              </div>
              <!---------> 
            </div>
            <!--------> 
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import utils from './Utils.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

export default {
  name: 'billinfo',
  props:['name', 'invoice', 'common_res', 'res', 'companyinfo', 'shippinginfo'],
  data () {
    return {
      toshowaddrs:false
    }
  },
  created: function() {
  },
  computed: {
  },
  components: {
  },
  methods: {
    isProforma() {
      return this.invoice.picode == null || this.invoice.invoiceNo == this.invoice.picode;
    },
    selectBranch(evt, info) {
      this.shippinginfo = info;
      this.toshowaddrs = false;
      utils.saveStorage('shippingid', info.bchid);
      this.$root.$emit('selectBranch', {'shippingid':info.bchid, 'extra_info':info.extracharge});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BillInfo.vue